import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { MessageService } from 'primeng/api';
import { FormGroup, NgForm } from '@angular/forms';
import { CountriesService } from 'src/app/countries/countries.service';
import { CoreFormService } from 'src/app/core/forms/core-forms.service';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';

@Component({
  selector: 'app-countries-detail',
  templateUrl: './countries-detail.component.html',
  styleUrls: ['./countries-detail.component.scss']
})

export class CountriesDetailComponent implements OnInit {
  @ViewChild("formDetails") public formDetails: NgForm;
  public country: any = {
    iso_code_2: "",
    iso_code_3: "",
    name: ""
  };

  constructor(
    private countriesService: CountriesService,
    private route: ActivatedRoute, private router: Router,
    private messageService: MessageService,
    private coreFormService: CoreFormService,
    private coreDialogService: CoreDialogService,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.loadData(params['id']);
    });
  }

  loadData(id: number) {
    if (id != 0) {
      this.countriesService.get(id).subscribe(
        data => {
          this.country = data;
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    }
  }

  cancel() {
    this.router.navigate(['/configuration/countries']);
  }

  save() {
    if (this.coreFormService.validate(this.formDetails)) {
      this.countriesService.save(this.country.id, this.country).subscribe(
        data => {
          var _msg = (this.country.id != 0 && typeof this.country.id !== "undefined") ? "modificado" : "añadido";
          this.messageService.add({ closable: false, severity: 'success', summary: "País " + _msg + " correctamente" });
          this.router.navigate(['/configuration/countries']);
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    }
  }

  delete() {
    this.coreDialogService.confirm({
      message: '¿Está seguro de que desea eliminar este elemento?',
      header: 'Confirmación de borrado',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.countriesService.delete(this.country.id).subscribe(
          res => {
            this.messageService.add({ closable: false, severity: 'success', summary: 'Elemento eliminado correctamente' });
            this.router.navigate(['/configuration/countries']);
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
          }
        );
      },
      reject: () => {

      }
    });
  }

  isDuplied() {
    var errorMessage = "";
    if (this.country.iso_code_2.length != 2) {
      errorMessage += "El código ISO 2 debe tener 2 carácteres. \n";
      this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: "El código ISO 2 debe tener 2 carácteres." });
    }
    if (this.country.iso_code_3.length != 3) {
      errorMessage += "El código ISO 3 debe tener 3 carácteres. \n";
      this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: "El código ISO 3 debe tener 3 carácteres" });
    }
    if (this.country.name.length <= 0) {
      //errorMessage += "El nombre no puede estar vacío. \n";
      this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: "El nombre no puede estar vacío." });
    }
    /*if(errorMessage){
      this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: errorMessage });
    }*/
    this.countriesService.isDuplied(this.country).subscribe(
      data => {
        if (data == true) {
          this.coreDialogService.notify({
            message: "Ya existe un país con estos datos proporcionados.",
            header: 'Error',
            icon: 'far exclamation-circle',
            color: 'var(--orange-500)',
            accept: () => { }
          });
        } else {
          this.save();
        }
      }
    );
  }
}
